import axios from "axios";

// For common config
axios.defaults.headers.post["Content-Type"] = "application/json";
export const api = axios.create({
  baseURL: `https://dev.raiserapi.blocsys.com/api/v1`,
  // baseURL: "http://localhost:4000/api/v1",
  // baseURL:"https://translations-magazines-nationally-convergence.trycloudflare.com/api/v1"
});
